<template>
    <mc-select
        v-if="!showText"
        v-model="innerValue"
        :source="list"
        :multiple="multiple"
        value-key="poiId"
        label-key="poiName"
        v-bind="$attrs"
        placeholder="请选择或输入搜索"
        :filterable="filterable"
        @change="onChange"
    >
        <template slot-scope="scope">
            <mc-tag
                v-if="showRegionType && scope.option"
                :theme="getTagColor(scope.option)"
            >
                {{ getTagText(scope.option) }}
            </mc-tag>
            {{ scope.option.label }}
        </template>
    </mc-select>
    <span v-else>{{ listText }}</span>
</template>

<script>
import { isEqual } from '@mcfe/tools';

const rdcRegionTypeMap = {
    0: { name: '全城仓', color: 'green' },
    1: { name: '南仓', color: 'purple' },
    2: { name: '北仓', color: 'orange' },
};

export default {
    // 通过经营城市获取RDC
    name: 'NewRdcSelect',
    props: {
        value: {
            type: [Array, Number, String],
            default: () => [],
            required: '',
        },
        cityIds: {
            type: Array,
            default: () => [],
            required: true,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        showText: {
            type: Boolean,
            default: false,
        },
        // 数据权限
        usePermission: {
            type: Boolean,
            default: false,
        },
        showRegionType: {
            type: Boolean,
            default: false,
        },
        filterable: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            list: [],
            // innerValue: this.value,
        };
    },
    computed: {
        innerValue: {
            get() { return Array.isArray(this.value) ? this.value : [this.value]; },
            set(val) { this.$emit('input', val); },
        },
        listText() {
            const listMap = this.list.reduce((result, item) => {
                result[item.poiId] = item.poiName;
                return result;
            }, {});
            if (this.multiple) {
                return this.innerValue.map((val) => listMap[val]).join(', ');
            } else {
                return listMap[+this.innerValue];
            }
        },
    },
    watch: {
        value(newVal) {
            this.innerValue = newVal;
        },
        cityIds(newVal, oldVal) {
            if (!isEqual(newVal, oldVal)) {
                this.getList();
            }
        },
    },
    created() {
        this.getList();
    },
    methods: {
        async getList() {
            try {
                const list = await this.$hPost('/api/vss/shepherd/product/queryRdcByManageCity', {
                    managementCityIdList: this.cityIds,
                    includeTestPoi: true,
                    usePermission: this.usePermission,
                });
                // 调整返回数据顺序
                const priorityMap = {
                    默认: 0, // 默认优先级最高
                    测试: 1,
                    停用: 2,
                    废弃: 3,
                };
                this.list = list.sort((a, b) => {
                    const aPriority = Object.keys(priorityMap).find((key) => a.poiName.includes(key)) || '默认';
                    const bPriority = Object.keys(priorityMap).find((key) => b.poiName.includes(key)) || '默认';
                    return priorityMap[aPriority] - priorityMap[bPriority];
                });
            } catch (error) {
                this.$message.error(error.msg || error.message || '获取仓列表失败');
            }
        },
        onChange(val, item) {
            this.$emit('change', val, item || { poiId: '', poiName: '' });
        },

        getTagColor(option) {
            return rdcRegionTypeMap[option.rdcRegionType]?.color || 'gray';
        },
        getTagText(option) {
            return rdcRegionTypeMap[option.rdcRegionType]?.name || '--';
        },
    },
};
</script>
